import { useCallback } from "react"
import { readContract } from "wagmi/actions"
import { config } from "../lib/wagmi"
import { newPool } from "../utils/contract"
import { formatEther, parseEther } from "viem"



export const useBondSize = ()=>{
    const bondSize =  useCallback (async (contractAddress)=>{

        const bondSize = await readContract(
            config,{
            address:contractAddress,
            abi:newPool.abi,
            functionName:"bondAmount",
            }
        )
        return bondSize
    },[])

    return {bondSize}
}